export const CALLBACK_URL_PARAM = 'redirectTo';
export const SOCIAL_AUTH_EVENT_PARAM = 'socialAuthEvent';
export const SOCIAL_AUTH_PROVIDER_PARAM = 'socialAuthProvider';
export const AUTH_GATE_PARAM = 'auth';
export const AUTH_GATE_HIDE_SOCIAL_PARAM = 'hideSocial';
export const AUTH_GATE_ORIGIN_PARAM = 'origin';
